<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Shuffle" class="d-icon d-icon--shuffle" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.647 1.647a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1-.707.707l-2.5-2.5a.5.5 0 0 1 0-.707Z" fill="currentColor"/><path d="M7.5 1.5A.5.5 0 0 1 8 1h2.5a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V2.707l-7.646 7.647a.5.5 0 0 1-.707-.707L9.293 2H8a.5.5 0 0 1-.5-.5Zm3 6a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H8a.5.5 0 1 1 0-1h1.293L7.147 7.854a.5.5 0 0 1 .707-.707L10 9.293V8a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconShuffle',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
